import { useSelector } from 'react-redux';
import useClientApiCopy from './useClientApiCopy';
import { mergeScreenCopy } from '../olbScreenCopy.helpers';
import { selectMatchedStrategyCollection } from '../../../Helpers/strategyCollection.helpers';

/**
 * The copy for one OLB screen block (`review` or `confirmation`): the file
 * bundle for the form's locale, with the form's per-strategy Capture copy merged
 * on top. Capture authors copy per form on the AppointmentPicking implementation,
 * keyed by the screen's step; a form that sends none renders the file labels, so
 * Amplifon is unchanged.
 */
const useOlbScreenCopy = (stepKey, screen) => {
  const fileCopy = useClientApiCopy();
  const captureBlock = useSelector(
    (store) =>
      selectMatchedStrategyCollection(store)?.implementations?.[stepKey]
        ?.copy?.[screen]
  );

  return mergeScreenCopy(fileCopy[screen], captureBlock);
};

export default useOlbScreenCopy;
